import Hero from '../components/Hero';
import StatsBar from '../components/StatsBar';
import Features from '../components/Features';
import SupportSection from '../components/SupportSection';
import AdditionalSections from '../components/AdditionalSections';
import HowItWorks from '../components/HowItWorks';
import GettingStarted from '../components/GettingStarted';
import SystemRequirements from '../components/SystemRequirements';
import Testimonials from '../components/Testimonials';
import SupportIssues from '../components/SupportIssues';
import FaqSection from '../components/FaqSection';
import CtaBanner from '../components/CtaBanner';
import Footer from '../components/Footer';
import FixedCallBar from '../components/FixedCallBar';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#f7faf7]">
      <Hero />
      <StatsBar />
      <Features />
      <SupportSection />
      <AdditionalSections />
      <HowItWorks />
      <CtaBanner
        kicker="Call or chat"
        title="Stuck mid-setup? We can walk you through it"
        text="Call or open live chat for install, upgrade, and migration help tailored to Windows or Mac."
        buttonLabel="Chat with an Expert"
      />
      <div className="t7-section--defer">
        <GettingStarted />
        <SystemRequirements />
        <Testimonials />
        <SupportIssues />
        <FaqSection />
      </div>
      <CtaBanner
        variant="light"
        kicker="Last step"
        title="Preserve your family history with confidence"
        text="Questions about TreeVault, sync, or missing media? Call or start a chat for clear next steps."
        buttonLabel="Open Live Chat"
      />
      <Footer />
      <FixedCallBar />
    </div>
  );
}
